import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

const getDeployment = async (promptbookId: string) => {
  const { data, error } = await supabase.from("deployments").select("*").eq("resource_id", promptbookId);

  if (error) {
    throw error;
  }

  return data?.[0] || null;
};

export const useDeployment = (promptbookId: string) => {
  return useQuery({
    queryKey: ["deployments", promptbookId],
    queryFn: () => getDeployment(promptbookId),
  });
};
